import { render, staticRenderFns } from "./VaccinationList.vue?vue&type=template&id=493fac9f&scoped=true&"
import script from "./VaccinationList.vue?vue&type=script&lang=js&"
export * from "./VaccinationList.vue?vue&type=script&lang=js&"
import style0 from "./VaccinationList.vue?vue&type=style&index=0&id=493fac9f&lang=scss&scoped=true&"
import style1 from "./VaccinationList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "493fac9f",
  null
  
)

export default component.exports